import React from 'react';
import { useDispatch } from 'src/state/redux';

import { DNABox, DNAModal, DNAText, luxColors } from '@alucio/lux-ui';
import { DNAModalActions } from 'src/state/redux/slice/DNAModal/DNAModal';

interface Props {
  closeUserDrawer: () => void;
}

const DNACloseUserDrawerConfirmation = (props: Props) => {
  const { closeUserDrawer } = props;
  const dispatch = useDispatch();

  function closeModal(): void {
    dispatch(DNAModalActions.closeModal());
  }

  function closeWithoutSaving(): void {
    closeUserDrawer();
    closeModal();
  }

  return (
    <DNAModal>
      <DNAModal.Header onClose={closeModal}>
        <DNAText h5>Unsaved changes</DNAText>
      </DNAModal.Header>
      <DNAModal.Body>
        <DNABox style={{ padding: 8 }}>
          <DNAText style={{ color: luxColors.flat.primary }}>All changes will be lost.</DNAText>
        </DNABox>
      </DNAModal.Body>
      <DNAModal.Confirmation
        onCancel={closeModal}
        cancelLabel="Continue editing"
        onAction={closeWithoutSaving}
        actionStatus="primary"
        actionLabel="Close without saving"
      />
    </DNAModal>
  )
};

export default DNACloseUserDrawerConfirmation;
